import {
CHANGE_DEFAULT_PERSON, SAVE_CHANGES, ADD_PERSON, SET_INIT_PERSONS, DELETE_PERSON
} from '../constants/clients-constants'

const initState = {
    "trans": {},
    "persons": []
};

export default function clients(state = initState, action) {
    switch ( action.type ) {
        case SAVE_CHANGES:
            return {
                ...state,
                persons: state.persons.map(person=> {
                    return person.key === action.key ? { ...person, ...action.data } : person;
                })
            };
        case CHANGE_DEFAULT_PERSON:
            return {
                ...state,
                persons: state.persons.map(person=> {
                    return person.key === action.key ? {
                        ...person,
                        default: true
                    } : {
                        ...person,
                        default: false
                    };
                })
            };
        case SET_INIT_PERSONS:
            return {
                ...state,
                persons: action.data
            };
        case DELETE_PERSON:
            if (checkIfHasActiveDefault(state.persons, action.key)) {
                return {
                    ...state,
                    persons: state.persons.filter(person=> {
                        return person.key !== action.key
                    }).map((person, i)=> {
                        return i == 0 ? {...person, default : true} : {...person, default : false};
                    })
                };
            } else {
                return {
                    ...state,
                    persons: state.persons.filter(person=> {
                        return person.key !== action.key
                    })
                };
            }
        case ADD_PERSON:
            return {
                ...state,
                persons: [ ...state.persons, {
                    id: "null",
                    key: state.persons.reduce((maxId, person) => Math.max(person.key, maxId), -1) + 1, ...action.data,
                    default: checkIfActiveDefault(state.persons) ? false : true
                } ]
            };
        default:
            return state;
    }
}

function checkIfActiveDefault(persons) {
    let hasDefaultValue = false;
    for ( var i = 0; i < persons.length; i++ ) {
        if (persons[ i ].default) {
            hasDefaultValue = true;
            break;
        }
    }
    return hasDefaultValue
}

function checkIfHasActiveDefault(persons, key) {
    let hasDefaultValue = false;
    for ( var i = 0; i < persons.length; i++ ) {
        if (persons[ i ].key === key && persons[ i ].default === true) {
            hasDefaultValue = true;
            break;
        }
    }
    return hasDefaultValue
}


// WEBPACK FOOTER //
// ./src/_app/clients/reducers/clients_reducer.js